export const zhI18n = {
  emptyText: "暂无数据",
  tableTotalNum: "共",
  tableTotalNum1: "条记录",
};

export const enI18n = {
  emptyText: "No data",
  tableTotalNum: "Total of ",
  tableTotalNum1: " records",
};
